module.exports = __webpack_public_path__ + "img/KC.145b0d0f.svg";